import {
  FixedScreenHeaderStack,
  Heading,
  Option,
  SearchAndAddBar,
  Select,
} from '~/common/components/defaultUIComponents';
import * as ReactRouter from 'react-router-dom';
import React, { useRef } from 'react';

import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from '@choc-ui/chakra-autocomplete';
import {
  Grid,
  GridItem,
  Icon,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { Ordering, useProjectContext } from './ProjectsContext';
import { CloseIcon, SearchIcon } from '@chakra-ui/icons';
import routes from '~/common/constants/routes.json';
import useTranslate from '~/common/utils/translate';
import { Sort } from '@material-ui/icons';
import _ from 'lodash';

export const ProjectHeader: React.FC = () => {
  const navigate = ReactRouter.useNavigate();
  const { setSearchTerm, orderType, setOrderType, filterTag, setFilterTag } =
    useProjectContext();
  const handleAdd = React.useCallback(() => {
    navigate(routes.CREATE_PROJECT);
  }, []);
  const { data: tags = [] } = ProjectApi.hooks.useProjectTags();
  const inputRef = useRef<HTMLInputElement>(null);
  const t = useTranslate();
  return (
    <FixedScreenHeaderStack>
      <Heading>project.heading</Heading>
      <Grid templateColumns="repeat(4, 1fr)" gap={1}>
        <GridItem colSpan={2}>
          <SearchAndAddBar
            onInputChange={setSearchTerm}
            onClick={handleAdd}
            inputPlaceholder="project.searchProjects.input.placeholder"
            tooltipLabel="project.newProject.tooltip.label"
          />
        </GridItem>
        <GridItem>
          <AutoComplete
            rollNavigation
            openOnFocus
            suggestWhenEmpty
            listAllValuesOnFocus
            filter={(query: string, _value: string, label: string) =>
              label.toLowerCase().includes(query.toLowerCase())
            }
            values={filterTag ? [filterTag] : []}
            onChange={(value) => setFilterTag(value as string)}
          >
            <InputGroup>
              <InputLeftElement>
                <SearchIcon />
              </InputLeftElement>
              <AutoCompleteInput
                placeholder={t('project.filter.tags')}
                onFocus={(e) => (e.target.value = '')}
                value={filterTag || ''}
                ref={inputRef}
              />
              <InputRightElement
                cursor="pointer"
                onClick={() => {
                  setFilterTag(undefined);
                  inputRef.current!.value = '';
                }}
              >
                <CloseIcon />
              </InputRightElement>
            </InputGroup>
            <AutoCompleteList>
              {_.orderBy(tags, [({ tag }) => tag]).map(({ tag }, index) => (
                <AutoCompleteItem
                  key={`tag-c-item-${tag}-${index}`}
                  value={tag}
                >
                  {tag}
                </AutoCompleteItem>
              ))}
            </AutoCompleteList>
          </AutoComplete>
        </GridItem>
        <GridItem>
          <Select
            value={orderType}
            onChange={(e) => setOrderType(e.target.value as Ordering)}
            minWidth="150px"
            left={
              <InputLeftElement>
                <Icon as={Sort} />
              </InputLeftElement>
            }
          >
            <Option value="alphabetical">project.orderBy.alphabetical</Option>
            <Option value="tag">project.orderBy.tag</Option>
          </Select>
        </GridItem>
      </Grid>
    </FixedScreenHeaderStack>
  );
};
